/* Author: Mihai Potra (http://mpotra.com)

*/
$(document).ready(function() {
      var liquid_check = "yes";
      var is_liquid = ( liquid_check === 'yes' ? true : false );
      
      $('#hero .slideshow .slides').cycle({
        fx: 'fade',
        timeout: 6000,
        slideResize: 0,
        containerResize:0,
        pager: '#hero .slideshow .slide-selector',
        activePagerClass:'selected',
        pause:1,
        pagerAnchorBuilder: function(i, el){
          if( is_liquid ) {
            return "<img src=\"//kshlerin-bruen5573.myshopify.com/cdn/shop/t/4/assets/selector-empty-18.png?v=1332879527\" />";
          } else {
            return '<img src="img/selector-empty-18.png" />';
          }
        },
        prev:'#hero .slideshow .arrow.left',
        next:'#hero .slideshow .arrow.right',
        after: function(currSlideElement, nextSlideElement, options, forwardFlag){
            $(currSlideElement).removeClass('show');
        },
        before: function(currSlideElement, nextSlideElement, options, forwardFlag){
            $(nextSlideElement).addClass('show');
        }
      });
    
    $('#toggle-note').toggle(
        function(){ $('#checkout-addnote').find('textarea').show(); }, 
        function(){ $('#checkout-addnote').find('textarea').hide();  }      
    );
});


